var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWarning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 17,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0E141A",
  d: "M2.806 17h15.06c1.54 0 2.5-1.67 1.73-3L12.066.99c-.77-1.33-2.69-1.33-3.46 0L1.076 14c-.77 1.33.19 3 1.73 3m7.53-7c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1m1 4h-2v-2h2z"
})));
export { SvgWarning as ReactComponent };
export default __webpack_public_path__ + "static/media/warning.ce13e14b.svg";